import { Autocomplete, Box, Grid, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

import { FormProvider, useForm } from 'react-hook-form';
import SelectFormItem from "components/Input/Select";
import { InputNumberForm, InputNumberNoForm, TextBoxForm } from "components/Input";
import Divider from "components/Divider";
import "./Register.css";
import { FiArrowRight } from "react-icons/fi";
import React, { useEffect } from "react";
import { RegisterContext } from "..";
import "assets/style/fontawesome-free-6.4.2-web/css/all.min.css";
import { AiFillCamera } from "react-icons/ai";
import { BsFillCameraFill } from "react-icons/bs";
import { SendAPIFile } from "utilities/Axios";
import { DatePickerFromItem } from "components/Input/DatePicker";
import { undefinedOrNull } from "utilities/Function";
import moment from "moment";
import { SwAlert } from "components";
import { AlertTitle } from "config/AlertMsgConfig";
const StepForm1 = () => {
  const { handleNext, objMasterData, formStep1, objFileImg, setobjFileImg, nSexID, setnSexID } = React.useContext(RegisterContext);

  const onUploadFile = () => {
    const onClickFile = document.getElementById("onCameraFile");
    if (onClickFile) {
      onClickFile.click();
    }
  }
  const _SendAPIFile = async (FileItem) => {

    let lstFile_ = FileItem.target.files;
    console.log("arrFileItem", lstFile_[0]);
    await SendAPIFile(lstFile_[0], (res) => {
      console.log("s", res);
      setobjFileImg(res[0]);
    }, (er) => {
      console.log("er", er);
    });

  }

  return (
    <FormProvider {...formStep1}>
      <Grid container direction="row">
        <Grid container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
          <Grid item md={12} xs={12}>
            <Divider>รายละเอียดการสมัครงาน</Divider>
          </Grid>
          <Grid item md={3} xs={12}>
            <SelectFormItem options={objMasterData?.lstPosition || []} name={"nPositionID"} label={"ตำแหน่งงานที่สนใจ"} required />
          </Grid>
          <Grid item md={2} xs={12}>
            <InputNumberForm name={"nSalary"} label={"เงินเดือนขั้นต่ำที่คาดหวัง"} required />
          </Grid>
          <Grid item md={3} xs={12}>
            <SelectFormItem options={objMasterData?.lstNewsSource || []} name={"nNewSourceID"} label={"แหล่งข่าวการสมัครงาน"} required />
          </Grid>
          <Grid item md={4} xs={12}>
            <SelectFormItem options={objMasterData?.lstRecruiting || []} name={"nRecruitmentID"} label={"ชื่อเจ้าหน้าที่สรรหา"} />
          </Grid>
          <Grid item md={12} xs={12}>
            <Divider>ข้อมูลส่วนบุคล</Divider>
          </Grid>
        </Grid>
        <Grid container direction="row" xs={12} md={1} sx={{}} marginBottom={1} spacing={2} alignItems="start" justifyContent="center" style={{ marginTop: "2.5px" }}>
          {/* <Grid item md={"auto"} xs={12} alignItems="end" justifyContent="end"> */}
          <div className="uploadimg" style={{ backgroundImage: objFileImg?.sFileUrl ? "url(" + objFileImg?.sFileUrl + ")" : "" }} >
            <div className="image-upload">
              <input style={{ display: "none" }} type="file" id="onCameraFile" accept="image/*" onChange={_SendAPIFile} />
              <div className="file-input" onClick={onUploadFile} >
                <BsFillCameraFill />
              </div>

            </div>
          </div>
          {/* </Grid> */}
        </Grid>
        <Grid container direction="row" xs={12} md={11} sm={12} spacing={2} marginBottom={1} id="divFrom1">
          <Grid item md={2} xs={12}>
            <TextBoxForm name={"sIDCard"} label={"เลขที่บัตรประชาชน"} maxLength={13} required />
          </Grid>
          <Grid item md={2} xs={12}>
            <DatePickerFromItem name={"dIDcardExpiration"} label={"วันที่หมดอายุ"} required
              fullWidth
              minDate={new Date()}
            />
          </Grid>
          {/* <Grid item md={8} xs={12}></Grid> */}
          <Grid item md={1.5} xs={12}>
            <SelectFormItem options={objMasterData?.lstPrefixName || []} name={"nPrefixID"} label={"คำนำหน้า"} required onChange={(e) => {
              if (e && e?.value === "9") {
                formStep1.setValue("nSexID", "15");
                setnSexID(15);
              } else {
                formStep1.setValue("nSexID", "16");
                setnSexID(16);
              }
              formStep1.setError("nSexID");
            }} />
          </Grid>
          <Grid item md={3.5} xs={12}>
            <TextBoxForm name={"sFirstName_TH"} label={"ชื่อ (ไทย)"} maxLength={250} required />
          </Grid>
          <Grid item md={3} xs={12}>
            <TextBoxForm name={"sLastName_TH"} label={"นามสกุล (ไทย)"} maxLength={250} required />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextBoxForm name={"sFirstName_EN"} label={"ชื่อ (อังกฤษ)"} maxLength={150} required isToUpperCase />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextBoxForm name={"sLastName_EN"} label={"นามสกุล (อังกฤษ)"} maxLength={150} required isToUpperCase />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextBoxForm name={"sNickname"} label={"ชื่อเล่น"} maxLength={50} required />
          </Grid>
          <Grid item md={2} xs={12}>
            <DatePickerFromItem name={"dBirthday"} label={"วันเกิด"} required
              maxDate={new Date(2010, 1, 1)}
              fullWidth
              minDate={new Date(1960, 1, 1)}
              onChange={(e) => {
                if (e) {
                  formStep1.setValue("nAge", moment().year() - e.year())
                }
              }}
            />
          </Grid>
          <Grid item md={2} xs={12}>
            <TextBoxForm name={"nAge"} label={"อายุ"} disabled />
          </Grid>
          <Grid item md={2} xs={12}>
            <SelectFormItem options={objMasterData?.lstNationality || []} name={"nNationalityID"} label={"สัญชาติ"} required />
          </Grid>
          <Grid item md={2} xs={12}>
            <SelectFormItem options={objMasterData?.lstNationality || []} name={"nEthnicityID"} label={"เชื้อชาติ"} required />
          </Grid>
          <Grid item md={2} xs={12}>
            <SelectFormItem options={objMasterData?.lstReligion || []} name={"nReligionID"} label={"ศาสนา"} required />
          </Grid>
          <Grid item md={2} xs={12}>
            <SelectFormItem options={objMasterData?.lstSex || []} name={"nSexID"} label={"เพศ"} required onChange={(e) => {
              if (e) setnSexID(undefinedOrNull(e.value, "number"))
            }} />
          </Grid>
          <Grid item md={4} xs={12}>
            <SelectFormItem options={objMasterData?.lstMaritalStatus || []} name={"nMaritalStatusID"} label={"สถานภาพ"} required />
          </Grid>
          <Grid item md={2} xs={12}>
            <InputNumberForm name={"nWeight"} label={"น้ำหนัก"} required />
          </Grid>
          <Grid item md={2} xs={12}>
            <InputNumberForm name={"nHeight"} label={"ส่วนสูง"} required />
          </Grid>
          {nSexID === 15 && <Grid item md={4} xs={12}>
            <SelectFormItem options={objMasterData?.lstMilitaryStatus || []} name={"nMilitaryStatusID"} label={"สถานภาพทางทหาร"} required />
          </Grid>}
        </Grid>
        <Grid marginTop={4} marginBottom={2} container direction="row" alignItems="start" justifyContent="end" sx={{}}>
          <button className="buttonNext" onClick={formStep1.handleSubmit(() => {
            if (objFileImg) {
              handleNext();
            } else {
              SwAlert.Warning(AlertTitle.Warning, "กรุณาอัปโหลดรูปภาพของท่าน", () => { });
            }
          })}>
            <span>ต่อไป</span>
            <FiArrowRight />
          </button>
        </Grid>
      </Grid>
    </FormProvider >
  )
};

export default StepForm1;
